// State-specific customizations for lawn care recommendations

export const stateExtensionServices = {
  'Alabama': 'Alabama Cooperative Extension System',
  'Alaska': 'University of Alaska Fairbanks Cooperative Extension Service',
  'Arizona': 'University of Arizona Cooperative Extension',
  'Arkansas': 'University of Arkansas Division of Agriculture',
  'California': 'UC Cooperative Extension',
  'Colorado': 'Colorado State University Extension',
  'Connecticut': 'UConn Extension',
  'Delaware': 'University of Delaware Cooperative Extension',
  'Florida': 'UF/IFAS Extension',
  'Georgia': 'University of Georgia Extension',
  'Hawaii': 'University of Hawaii at Manoa Cooperative Extension',
  'Idaho': 'University of Idaho Extension',
  'Illinois': 'University of Illinois Extension',
  'Indiana': 'Purdue Extension',
  'Iowa': 'Iowa State University Extension and Outreach',
  'Kansas': 'K-State Research and Extension',
  'Kentucky': 'University of Kentucky Cooperative Extension Service',
  'Louisiana': 'LSU AgCenter',
  'Maine': 'University of Maine Cooperative Extension',
  'Maryland': 'University of Maryland Extension',
  'Massachusetts': 'UMass Extension',
  'Michigan': 'MSU Extension',
  'Minnesota': 'University of Minnesota Extension',
  'Mississippi': 'Mississippi State University Extension Service',
  'Missouri': 'University of Missouri Extension',
  'Montana': 'MSU Extension',
  'Nebraska': 'Nebraska Extension',
  'Nevada': 'University of Nevada Cooperative Extension',
  'New Hampshire': 'UNH Cooperative Extension',
  'New Jersey': 'Rutgers Cooperative Extension',
  'New Mexico': 'New Mexico State University Cooperative Extension Service',
  'New York': 'Cornell Cooperative Extension',
  'North Carolina': 'NC Cooperative Extension',
  'North Dakota': 'NDSU Extension',
  'Ohio': 'OSU Extension',
  'Oklahoma': 'Oklahoma Cooperative Extension Service',
  'Oregon': 'Oregon State University Extension Service',
  'Pennsylvania': 'Penn State Extension',
  'Rhode Island': 'University of Rhode Island Cooperative Extension',
  'South Carolina': 'Clemson Cooperative Extension',
  'South Dakota': 'SDSU Extension',
  'Tennessee': 'UT Extension',
  'Texas': 'Texas A&M AgriLife Extension',
  'Utah': 'Utah State University Extension',
  'Vermont': 'University of Vermont Extension',
  'Virginia': 'Virginia Cooperative Extension',
  'Washington': 'WSU Extension',
  'West Virginia': 'WVU Extension Service',
  'Wisconsin': 'University of Wisconsin-Madison Division of Extension',
  'Wyoming': 'University of Wyoming Extension'
};

// State-specific task modifications
export const stateSpecificModifications = {
  // Tropical states - different soil and grass considerations
  'Hawaii': {
    soilTestingNote: 'Hawaii soils are often volcanic and acidic. Consider testing for pH, aluminum toxicity, and micronutrients.',
    inappropriateTasks: ['snow', 'ice', 'frozen', 'winter protection', 'frost'],
    grassRecommendations: ['St. Augustine', 'Seashore Paspalum', 'Zoysia'],
    specialConsiderations: [
      'Year-round growing season',
      'High humidity and salt exposure near coasts',
      'Volcanic soil characteristics',
      'Tropical pest considerations'
    ]
  },
  
  // Desert states - water conservation focus
  'Arizona': {
    soilTestingNote: 'Desert soils are often alkaline and low in organic matter. Test for pH, salinity, and nutrient deficiencies.',
    inappropriateTasks: ['overseeding with cool-season grass'],
    grassRecommendations: ['Bermuda', 'Buffalo Grass', 'Desert-adapted varieties'],
    specialConsiderations: [
      'Water conservation critical',
      'Heat stress management',
      'Alkaline soil amendments needed',
      'Monsoon season considerations'
    ]
  },
  
  'Nevada': {
    soilTestingNote: 'Nevada soils are typically alkaline with low organic matter. Test pH and consider sulfur amendments.',
    inappropriateTasks: ['overseeding with cool-season grass in southern areas'],
    grassRecommendations: ['Bermuda', 'Buffalo Grass', 'Tall Fescue (northern areas)'],
    specialConsiderations: [
      'Water restrictions common',
      'Extreme temperature variations',
      'Alkaline soil management',
      'High altitude considerations (northern areas)'
    ]
  },
  
  // Coastal states - salt exposure
  'Florida': {
    soilTestingNote: 'Florida soils vary from sandy to clay. Test for pH, nutrients, and salt levels in coastal areas.',
    inappropriateTasks: ['snow', 'ice', 'frozen', 'overseeding with cool-season grasses'],
    grassRecommendations: ['St. Augustine', 'Bermuda', 'Zoysia', 'Bahia'],
    specialConsiderations: [
      'Hurricane season lawn prep',
      'High humidity fungal issues',
      'Sandy soil drainage',
      'Salt tolerance near coasts'
    ]
  },
  
  // Northern states - short growing season
  'Alaska': {
    soilTestingNote: 'Alaska soils may have permafrost issues and short growing seasons. Test for pH and nutrient availability.',
    inappropriateTasks: ['warm-season grass tasks'],
    grassRecommendations: ['Fine Fescue', 'Hardy cool-season varieties'],
    specialConsiderations: [
      'Very short growing season',
      'Permafrost considerations',
      'Extreme cold tolerance needed',
      'Limited grass variety options'
    ]
  }
};

// Get state-specific extension service
export const getStateExtensionService = (state) => {
  return stateExtensionServices[state] || 'your local cooperative extension service';
};

// Get state-specific modifications
export const getStateModifications = (state) => {
  return stateSpecificModifications[state] || {};
};

// Check if task is inappropriate for state
export const isTaskInappropriateForState = (taskText, state) => {
  const stateInfo = stateSpecificModifications[state];
  if (!stateInfo || !stateInfo.inappropriateTasks) return false;
  
  const lowerTaskText = taskText.toLowerCase();
  return stateInfo.inappropriateTasks.some(inappropriate => 
    lowerTaskText.includes(inappropriate.toLowerCase())
  );
};